var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('File',{attrs:{"id":_vm.TAB_IDS.PlaySnake}},[_c('SnakeGame')],1)}
var staticRenderFns = []

export { render, staticRenderFns }